exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-image{cursor:pointer}.upload-image img{border-radius:6px;object-fit:cover}.upload-image:hover figure:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);z-index:1;border-radius:6px}.upload-image i{opacity:0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:2rem;color:#fff;z-index:2}.upload-image:hover i{opacity:1;background-color:#522687;border-radius:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f8a8546e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/empresas/components/SideMenu.vue
// module id = 652
// module chunks = 2